export const selectMLScoreState = state => state.mlScoreState;

export const selectMLScoreRanges = state =>
  state.mlScoreState.mlScoreSliderSettings.mlScoreRanges;

export const selectMLScoreColors = state =>
  state.mlScoreState.mlScoreSliderSettings.mlScoreColors;
